module.exports = __webpack_public_path__ + "img/vendor-pushed.2b44022a.svg";